import {
	HttpInterceptor,
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpClient
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DeviceService } from './device.service';
import { GlobalSearchService } from './globalsearchservice.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	private localStorageKey = 'v8ConfigOverride';

	private config: any = null;

	constructor(
    private injector: Injector,
    private deviceService: DeviceService
	) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const uuid = this.deviceService.getDeviceUUID();
  
		const localConfig = localStorage.getItem('v8ConfigOverride');
		const localUser = localStorage.getItem('user');
  
		let token = null;
  
		try {
			const config = JSON.parse(localConfig || '{}');
			const user = JSON.parse(localUser || '{}');
  
			if (config?.apiCredentials?.clientId && user?.user?.userid) {
				token = `${config.apiCredentials.clientId}_${user.user.userid}`;
			}
		} catch (_) {}
  
		const headers: any = { 'X-Device-UUID': uuid };
  
		if (token) {
			headers['Authorization'] = `Bearer ${token}`;
		}
  
		const authReq = req.clone({ setHeaders: headers });
		return next.handle(authReq);
	}

	private async ensureConfigLoaded(): Promise<void> {
		if (this.config) {return;}

		const http = this.injector.get(HttpClient);
		const globalSearchService = this.injector.get(GlobalSearchService);

		try {
			const local = localStorage.getItem(this.localStorageKey);
			if (local) {
				this.config = JSON.parse(local);
				if (!globalSearchService.isValidConfig(this.config)) {throw new Error('Invalid config');}
			} else {
				throw new Error('Missing local config');
			}
		} catch {
			const url = `assets/config/config.${environment.name}.json?t=${Date.now()}`;
			this.config = await http.get(url).toPromise();
		}

		// Set it globally so the rest of the app can use it
		globalSearchService.setConfig(this.config);
	}
}